export const subscriptionPlans = [
  {
    id: 1,
    title: "Silver Membership-3",
    price: 499,
    duration: 3,
    members: 1,
    perks: [
      "Monthly wellness assessment (Body Compositions Analysis)",
      "BP check",
      "Personalised counselling",
    ],
  },
  {
    id: 2,
    title: "Gold Membership-3",
    price: 949,
    duration: 3,
    members: 2,
    perks: [
      "Monthly wellness assessment (Body Compositions Analysis)",
      "BP check",
      "Personalised counselling",
    ],
  },
  {
    id: 3,
    title: "Platinum Membership-3",
    price: 1399,
    duration: 3,
    members: 3,
    perks: [
      "Monthly wellness assessment (Body Compositions Analysis)",
      "BP check",
      "Personalised counselling",
    ],
  },
  {
    id: 4,
    title: "Star Membership-3",
    price: 1849,
    duration: 3,
    members: 4,
    perks: [
      "Monthly wellness assessment (Body Compositions Analysis)",
      "BP check",
      "Personalised counselling",
    ],
  },
  {
    id: 5,
    title: "Diamond Membership-3",
    price: 2299,
    duration: 3,
    members: 5,
    perks: [
      "Monthly wellness assessment (Body Compositions Analysis)",
      "BP check",
      "Personalised counselling",
    ],
  },
  {
    id: 6,
    title: "Silver Membership-12",
    price: 1899,
    duration: 12,
    members: 1,
    perks: [
      "Monthly wellness assessment (Body Compositions Analysis)",
      "BP check",
      "Personalised counselling",
    ],
  },
  {
    id: 7,
    title: "Gold Membership-12",
    price: 3699,
    duration: 12,
    members: 2,
    perks: [
      "Monthly wellness assessment (Body Compositions Analysis)",
      "BP check",
      "Personalised counselling",
    ],
  },
  {
    id: 8,
    title: "Platinum Membership-12",
    price: 5499,
    duration: 12,
    members: 3,
    perks: [
      "Monthly wellness assessment (Body Compositions Analysis)",
      "BP check",
      "Personalised counselling",
    ],
  },
  {
    id: 9,
    title: "Star Membership-12",
    price: 7299,
    duration: 12,
    members: 4,
    perks: [
      "Monthly wellness assessment (Body Compositions Analysis)",
      "BP check",
      "Personalised counselling",
    ],
  },
  {
    id: 10,
    title: "Diamond Membership-12",
    price: 9099,
    duration: 12,
    members: 5,
    perks: [
      "Monthly wellness assessment (Body Compositions Analysis)",
      "BP check",
      "Personalised counselling",
    ],
  },
];
